import React from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import { Modal } from "semantic-ui-react";

const ConfirmModal = ({ isOpen, title, mainText, confirmAction, cancelAction, confirmText, cancelText, hookToTop, small }) => {
	const titleElement = title ? <h2>{title}</h2> : null;

	const showOnTop = hookToTop;

	const scrollYSize = window.parent.scrollY;
	let top = 0;
	const confirmHeight = 220;
	const headerHeight = 314;

	if (!showOnTop) {
		if (window.innerHeight === window.parent.innerHeight) {
			// lokaal
			top = ((window.innerHeight + confirmHeight) / 2);
		}
		else {
			const x = headerHeight - scrollYSize + (confirmHeight / 2);
			top = window.parent.innerHeight / 2 - x;
			top = top > (window.innerHeight - confirmHeight * 2) ? window.innerHeight - confirmHeight * 2 : top;
			top = top < (confirmHeight / 2) ? (confirmHeight / 2) : top;
		}
	}
	else {
		top = headerHeight;
	}

	if (isOpen)
		window.parent.scrollTo(0, top);

	const style = { bottom: 'auto', top: top };
	const buttonStyle = small ? { marginTop: '0px' } : null;

	return (
		<Modal
			style={style}
			open={isOpen}>
			<Modal.Content>
				{titleElement}
				<div>{mainText}</div>
			</Modal.Content>
			<Modal.Actions className={"c-form__actions"} style={buttonStyle}>
				{cancelText ? <Button onClick={cancelAction} autoFocus text={cancelText} /> : null}<Button onClick={confirmAction} text={confirmText} />
			</Modal.Actions>
		</Modal>
	);
};

ConfirmModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	title: PropTypes.string,
	mainText: PropTypes.string.isRequired,
	confirmAction: PropTypes.func.isRequired,
	cancelAction: PropTypes.func,
	confirmText: PropTypes.string.isRequired,
	cancelText: PropTypes.string,
	hookToTop: PropTypes.bool,
	small: PropTypes.bool
};

export default ConfirmModal;
